import * as React from "react";
import styled from "styled-components";
import Tabs, { Tab } from "@8x8/oxygen-tabs";

import PageTitle from "@/react/components/PageTitle";
import TableWrapper from "@/react/features/styled/TableWrapper";
import ContentWrapper from "@/react/features/styled/PageContentContainer";

import { AllQueues, InboundPhoneQueues } from "./tabs";

const StyledTabs = styled(Tabs)`
  margin: 0;
`;

const Tables = Object.freeze({
  ALL_QUEUES: "All",
  INBOUND_PHONE_QUEUES: "Inbound Phone",
});

const QueuesPage = () => {
  const [selectedTable, setSelectedTable] = React.useState(Tables.ALL_QUEUES);

  return (
    <ContentWrapper>
      <PageTitle>Queues</PageTitle>
      <StyledTabs>
        {Object.values(Tables).map((tableName) => (
          <Tab
            key={tableName}
            onClick={() => setSelectedTable(tableName)}
            isActive={selectedTable === tableName}
          >
            <h6>{tableName}</h6>
          </Tab>
        ))}
      </StyledTabs>
      <TableWrapper>
        {selectedTable === Tables.ALL_QUEUES && <AllQueues />}
        {selectedTable === Tables.INBOUND_PHONE_QUEUES && (
          <InboundPhoneQueues />
        )}
      </TableWrapper>
    </ContentWrapper>
  );
};

export default QueuesPage;
